import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { api, ApiError } from "@/lib/api";
import { brandColors as colors } from "@/lib/palette";
import { fonts } from "@/lib/fonts";
import type { GuideDetail as GuideDetailType } from "@/lib/guides";
import GuideDetailPage from "@/components/pages/GuideDetailPage";

type Resp = { guide: GuideDetailType };

export function GuideDetail() {
  const { guideSlug } = useParams<{ topicSlug: string; guideSlug: string }>();
  const [data, setData] = useState<Resp | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!guideSlug) return;
    setData(null);
    setErr(null);
    setNotFound(false);
    api
      .get<Resp>(`/api/guides/${guideSlug}`)
      .then(setData)
      .catch((e) => {
        if (e instanceof ApiError && e.status === 404) {
          setNotFound(true);
          return;
        }
        setErr(e instanceof Error ? e.message : "Failed to load guide");
      });
  }, [guideSlug]);

  if (notFound) {
    return (
      <div
        className="min-h-dvh px-6 py-32 text-center"
        style={{ backgroundColor: colors.cream, fontFamily: fonts.body, color: colors.navy }}
      >
        Guide not found.
      </div>
    );
  }
  if (err) {
    return (
      <div
        className="min-h-dvh px-6 py-32 text-center"
        style={{ backgroundColor: colors.cream, color: colors.berryRose, fontFamily: fonts.body }}
      >
        {err}
      </div>
    );
  }
  if (!data) {
    return (
      <div
        className="min-h-dvh px-6 py-32 text-center"
        style={{ backgroundColor: colors.cream, color: `${colors.navy}88`, fontFamily: fonts.body }}
      >
        Loading…
      </div>
    );
  }
  return <GuideDetailPage guide={data.guide} />;
}
